import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import { WelcomeBox, WindowTitle } from '@homeviews/shared-ui'
import { ResetPasswordForm } from '@homeviews/auth'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
)

const Login: FC = () => {
  const classes = useStyles()

  return (
    <>
      <WindowTitle title="Reset Password" />
      <div className={classes.root}>
        <WelcomeBox title="Reset Password">
          <ResetPasswordForm />
        </WelcomeBox>
      </div>
    </>
  )
}

export default Login
